import React from 'react'
import styled, { css } from 'styled-components'
import { HeroContentContainer, Hero, LogoLink, Logo } from './layout'
import { Footer, Sidebar, Content } from '../../layouts'
import {
  RecordReplySidebar,
  ToggleRecordReplySidebarButton,
  useRecordReplySidebar
} from '@mote/presentation'
import { isMobile } from '@mote/helpers/browser'

export const MoteLandingLayout = ({ hero, children }) => {
  const { state, toggle } = useRecordReplySidebar()

  return (
    <Root>
      <Container isSidebarOpen={state.isOpen} sidebarPosition='right'>
        <Header>
          <LogoLink href='/'>
            <Logo src='/images/logos/mote-lockup-header.png' alt='mote logo' />
          </LogoLink>
          {!isMobile() && <ToggleRecordReplySidebarButton />}
        </Header>

        <Hero>
          <Content>
            <HeroContentContainer>{hero}</HeroContentContainer>
          </Content>
        </Hero>

        {children && <StyledContent>{children}</StyledContent>}
        <Footer />
      </Container>
      <StyledSidebar
        isOpen={state.isOpen}
        onToggle={toggle}
        position='right'
        width={375}
      >
        <StyledSidebarContent layout='vertical' spreadX spreadY>
          <RecordReplySidebar />
        </StyledSidebarContent>
      </StyledSidebar>
    </Root>
  )
}

const Header = ({ children, ...rest }) => {
  return (
    <HeaderRoot {...rest}>
      <HeaderContainer>
        <HeaderContent>{children}</HeaderContent>
      </HeaderContainer>
    </HeaderRoot>
  )
}

const HeaderRoot = styled.header`
  position: sticky;
  height: 88px;
  top: 0;
  z-index: 30;
  background-color: #fafafc;
`

const HeaderContainer = styled.div`
  height: 100%;
`

const HeaderContent = styled(Content)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`

const Root = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
`

const Container = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
  transition: margin 150ms ease-in-out;
  padding: 0;

  ${({ isSidebarOpen, sidebarPosition }) =>
    isSidebarOpen &&
    css`
      margin-left: ${sidebarPosition === 'left' ? 375 : 0}px;
      margin-right: ${sidebarPosition === 'right' ? 375 : 0}px;

      @media (max-width: 920px) {
        margin: 0;
      }
    `};
`

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  padding: 0 16px !important;
`

const StyledSidebar = styled(Sidebar)`
  padding: 0;

  ${isMobile() &&
  css`
    width: 100% !important;
  `};
`

const StyledSidebarContent = styled(Sidebar.Content)`
  padding: 0;
  background: #ffffff;
  overflow: hidden;
  border-left: 1px solid #d1d1e0;
  display: grid;
  grid-template-rows: auto 1fr;

  @media (max-width: 920px) {
    border-left: none;
  }
`
